module.exports = __webpack_public_path__ + "static/media/GWE-PinwheelInstructions(FRA).e4f0d027.pdf";